package navigation.home.service

import navigation.home.service.addeditservice.AddEditServiceScreenModel
import navigation.home.service.allservice.AllServiceScreenModel
import navigation.home.service.addextraservice.AddExtraServiceScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val serviceUiModule
    get() =
        module {
            factory {
                AllServiceScreenModel(
                    serviceRepository = get(),
                    categoryRepository = get(),
                    tagRepository = get(),
                    areaRepository = get(),
                    loadingManager = get(),
                    extraCategoryServiceUseCase = get(),
                    getCurrentUserUseCase = get(),
                )
            }

            factory {
                AddEditServiceScreenModel(
                    serviceRepository = get(),
                    categoryRepository = get(),
                    tagRepository = get(),
                    fileRepository = get(),
                    areaRepository = get(),
                    supplierRepository = get(),
                    getCurrentUserUseCase = get(),
                    toastManager = get(),
                    openAIClient = get(),
                    loadingManager = get(),
                )
            }

            factoryOf(::AddExtraServiceScreenModel)
        }
